<template>
    <div>
        <b-card :header="uLang('app.create')" header-tag="h4" class="bg-default-card">
            <action-form v-if="project && trajectory && milestone" :project="project" :trajectory="trajectory" :milestone="milestone" :overrideEndpoint="overrideEndpoint"/>
        </b-card>
    </div>
</template>

<script>
    import ActionForm from '~/components/forms/admin/projects/action/form'

    export default {
        name: 'create',

        props: {
            projectId: {
                required: true,
            },
            trajectoryId: {
                required: true,
            },
            milestoneId: {
                required: true,
            },
        },

        components: {
            'action-form': ActionForm,
        },

        data() {
            return {
                project: undefined,
                trajectory: undefined,
                milestone: undefined,
            };
        },

        created() {
            this.retrieveProject();
            this.retrieveTrajectory();
            this.retrieveMilestone();
        },

        methods: {
            async retrieveProject() {
                const {data} = await window.axios.get(route('trajectory-projects.show', { trajectory_project: this.projectId }));
                this.project = data;
            },

            async retrieveTrajectory() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.show', { trajectory_project: this.projectId, trajectory: this.trajectoryId }));
                this.trajectory = data;
            },

            async retrieveMilestone() {
                const {data} = await window.axios.get(route('trajectory-projects.trajectories.milestones.show', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.milestoneId }));
                this.milestone = data;
            },
        },

        computed: {
            overrideEndpoint() {
                return route('trajectory-projects.trajectories.milestones.actions.store', { trajectory_project: this.projectId, trajectory: this.trajectoryId, milestone: this.milestoneId })
            }
        },
    }
</script>

<style lang="css" scoped>
</style>